import { FETCH_AREA_OF_SPECIALITY } from "./index";

export const setAreaOfSpeciality = (payload) => {
  return {
    type: FETCH_AREA_OF_SPECIALITY,
    payload: payload,
  };
};
